<script setup>
import {
  ref,
  reactive,
  onMounted
} from 'vue'
import {
  KkModal,
  KkCheckbox,
  KkButton,
} from '../../../../components/base'
import {
  KkSearchForm
} from '../../../../components/ui'
import {
  KkAccountContainer
} from '../../../../components/domains/sns'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const searchWord = ref('')
const displayedAccounts = ref([])

const emit = defineEmits(['submit', 'close'])
const state = reactive({
  checkIds: []
})
const props = defineProps({
  accounts: { type: Array, required: true },
  openModal: { type: Boolean, default: false },
  checkIds: { type: Array, required: true }
})
const handleSubmit = () => {
  emit('submit', state.checkIds)
}

const checkAccounts = (id) => {
  if(state.checkIds.includes(id)) {
    state.checkIds = state.checkIds.filter(v => v !== id)
  } else {
    state.checkIds.push(id)
  }
}

const checkAllAccounts = () => {
  if(state.checkIds.length === props.accounts.length) {
    state.checkIds = []
  } else {
    state.checkIds = props.accounts.map(v => `${v.type}-${v.id}`)
  }
}

const search = () => {
  displayedAccounts.value = props.accounts.filter(v => v.name.indexOf(searchWord.value) != -1)
}

onMounted(() => {
  state.checkIds = props.checkIds
  displayedAccounts.value = props.accounts
})
</script>
<template>
  <KkModal :is-visible="props.openModal" width="720px" @change="emit('close')">
    <div class="content__header">
      {{ t('pages.CompaniesStoreSnsPost.form.accountsModal.title') }}
    </div>
    <div class="content__body">
      <div class="content__body__header">
        <div class="allCheck">
          <KkCheckbox
            id="allCheckModal"
            :model-value="state.checkIds.length === accounts.length"
            :label="t('pages.CompaniesStoreSnsPost.form.accountsModal.allCheck')"
            @change="checkAllAccounts"
          />
        </div>
        <KkSearchForm
          v-model="searchWord"
          class="search"
          :placeholder="t('pages.CompaniesStoreSnsPost.form.accountsModal.search')"
          @search="search"
        />
      </div>
      <KkAccountContainer
        :accounts="displayedAccounts"
        :show-check="true"
        :check-ids="state.checkIds"
        @check="checkAccounts($event)"
      />
    </div>
    <div class="content__footer">
      <div class="c-button">
        <i18n-t keypath="pages.CompaniesStoreSnsPost.form.accountsModal.accountsCount" class="account-count-wap">
          <span class="account-count">{{ state.checkIds.length }}</span>
        </i18n-t>
        <div class="buttonItem">
          <KkButton
            color="secondary"
            outlined
            :text="t('labels.cancel')"
            @click="emit('close')"
          />
        </div>
        <div class="buttonItem">
          <KkButton
            color="primary"
            :disabled="state.checkIds.length === 0"
            :text="t('labels.confirm')"
            @click="handleSubmit"
          />
        </div>
      </div>
    </div>
  </KkModal>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid $color-base-c;
    font-size: 16px;
    line-height: 1.5;
  }

  &__footer {
    padding: 32px;
    border-top: 1px solid $color-base-c;
  }

  &__body {
    height: 50vh;
    padding: 32px;
    overflow-y: scroll;

    &__header{
      display: flex;
      justify-content: flex-start;
      align-content: center;
      margin-bottom: 16px;
      .search {
        margin-left: auto;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}
.allCheck {
  display: flex;
  font-weight: bold;
  margin: auto 0 0 14px;
}

.account-count-wap {
  margin-right: 10px;
}
.account-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}
.buttonItem {
  margin-left: 10px;
}
</style>
